const minMaxPrice = ({
  filterForm,
  pricesSelector = `.js-filter-price`,
  minPriceSelector = `.js-filter-min-price`,
  maxPriceSelector = `.js-filter-max-price`,
  IMask,
}) => {
  const pricesElement = filterForm.querySelector(pricesSelector);

  if (pricesElement) {
    const minPriceElement = pricesElement.querySelector(minPriceSelector);
    const maxPriceElement = pricesElement.querySelector(maxPriceSelector);

    const maskOption = {
      mask: Number,
      min: 0,
    };

    const minMax = IMask(minPriceElement, maskOption);
    const maxMask = IMask(maxPriceElement, maskOption);

    minPriceElement.addEventListener(`input`, (evt) =>
      maxMask.updateOptions({min: +minPriceElement.value}),
    );
  }
};

export default minMaxPrice;
